export const stripHtml = (html: string) => {
    const parser = new DOMParser();
    const textString = parser.parseFromString(html, `text/html`);
    const textOnly = textString.querySelector(`body`).textContent;
    return textOnly;
};